export default {
  name: "姓名",
  tel: "電話",
  save: "保存",
  confirm: "確定",
  cancel: "取消",
  delete: "刪除",
  complete: "完成",
  loading: "加載中...",
  telEmpty: "請填寫電話",
  nameEmpty: "請填寫姓名",
  nameInvalid: "請輸入正確的姓名",
  confirmDelete: "確定要刪除嗎",
  telInvalid: "請輸入正確的手機號",
  SelectYearMonthDay: "選擇年、月、日",
  vanCalendar: {
    end: "結束",
    start: "開始",
    title: "日期選擇",
    confirm: "確定",
    startEnd: "開始/結束",
    weekdays: ["日", "一", "二", "三", "四", "五", "六"],
    monthTitle: "(year, month) => ${year}年${month}月",
    rangePrompt: "(maxRange) => 選擇天數不能超過 ${maxRange} 天",
  },
  vanCascader: {
    select: "請選擇",
  },
  vanContactCard: {
    addText: "添加聯絡人",
  },
  vanContactList: {
    addText: "新增聯絡人",
  },
  vanPagination: {
    prev: "上一頁",
    next: "下一頁",
  },
  vanPullRefresh: {
    pulling: "下拉即可刷新...",
    loosing: "釋放即可刷新...",
  },
  vanSubmitBar: {
    label: "合計：",
  },
  vanCoupon: {
    unlimited: "無使用門檻",
    discount: "(discount) => ${discount}折",
    condition: "(condition) => 滿${condition}元可用",
  },
  vanCouponCell: {
    title: "優惠券",
    tips: "暫無可用",
    count: "(count) => ${count}張可用",
  },
  vanCouponList: {
    empty: "暫無優惠券",
    exchange: "兌換",
    close: "不使用優惠券",
    enable: "可用",
    disabled: "不可用",
    placeholder: "請輸入優惠碼",
  },
  vanAddressEdit: {
    area: "地區",
    postal: "郵政編碼",
    areaEmpty: "請選擇地區",
    addressEmpty: "請填寫詳細地址",
    postalEmpty: "郵政編碼格式不正確",
    defaultAddress: "設為默認收貨地址",
    telPlaceholder: "收貨人手機號",
    namePlaceholder: "收貨人姓名",
    areaPlaceholder: "選擇省 / 市 / 區",
  },
  vanAddressEditDetail: {
    label: "詳細地址",
    placeholder: "街道門牌、樓層房間號等資訊",
  },
  vanAddressList: {
    add: "新增地址",
  },

  realName: "姓名",
  idCard: "身份证",

  unionManagement: {
    GuildRegistration: "公會入駐",
    ApplicantID: "申請人ID",
    GuildName: "公會名稱",
    PleaseGuildName: "請輸入公會名稱",
    PleaseGuildID: "請輸入公會ID",
    PleaseInformation: "請輸入你的聯繫方式",
    PlatformsWith: "合作過的平台",
    ListOfplatforms: "列舉合作過的平台",
    GuildSize: "公會規模",
    EstimatedNumber: "預計公會主播人數",
    Notes: "注:可聯繫公會長或公會成員獲取公會ID",
    Submit: "提交",
    SubmitSuccess: "提交成功",
    MyGuild: "我的公會",
    VoiceHallOnboarding: "語音廳入駐",
    VoiceHallName: "語音廳名稱",
    PleaseVoiceHallName: "請輸入語音廳名稱",
    WhatsApp: "WhatsApp",
    PleaseContactInfo: "請輸入你的聯繫方式",
    PlatformsCollaborated: "合作過的平台",
    ListPlatformsCollaborated: "列舉合作過的平台",
    VoiceHallScale: "語音廳規模",
    EstimatedAnchors: "預計語音廳主播人數",
    CertificationType: "認證類型",
    VoiceHall: "語音廳",
    VoiceGuild: "語音公會",
    HostName: "主播名稱",
    GuildJoinDate: "加入公會時間",
    TotalMembers: "公會總人數",
    TotalPeople: "總人數",
    DataDetails: "數據詳情",
    PleaseHostID: "請輸入主播ID",
    Search: "搜索",
    KickOut: "踢出",
    NoData: "暫無數據",

    InformationData: "信息數據",
    Name: "姓名",
    PleaseID: "請確保與證件上的姓名一致",
    IdentityCard: "身份證",
    YourIDnumber: "您的身份證號碼",
    IDPhoto: "身份證照片",
    PleasePhoto: "請上傳您的身份證照片",
    FrontofID: "身份證正面",
    BackofID: "身份證反面",
    NotePlease:
      "注：請上傳您手持證件的照片，要求面部清晰无遮挡，證件照片及號碼需清晰可見",
    Country: "國家",
    SelectCountryorRegion: "選擇國家/地區",
    BankName: "銀行名稱",
    Pleasebankname: "請填寫開戶銀行名稱",
    BankCardNumber: "銀行卡號碼",
    Pleasebankcardnumber: "請填寫您的銀行卡號碼",
    BankCardHolder: "銀行卡持有人的姓名",
    Pleasebankcardholder: "請填寫銀行卡持有人的姓名",
    PhoneNumber: "手機號",
    Enterphonenumber: "輸入正確的手機號碼",
    Notebankaccount: "注：請輸入銀行預留的手機號碼。",
    WhatsAppContactInformation: "WhatsApp 聯繫方式",
    Pleaseownnumber: "請務必填寫本人的手機號碼。",
    Notecollaborationmatters:
      "注：公會提供的 WhatsApp 聯繫方式將被視為唯一的合作聯繫方式。",
    Email: "電子郵件",
    Pleaseemailaddress: "請務必填寫本人的電子郵件地址。",
    Notematters: "注：公會提供的電子郵件將被視為唯一的合作聯繫方式。",

    SpecialGiftDetails: "特效禮物明細",
    CurrentDate: "當前日期",
    GoldCoinTransactions: "金幣流水",
    LiveStreamingDuration: "直播時長",
    GoldBeanEarnings: "金豆收益",
    EffectiveDays: "有效天數",
    WarningCount: "警告次數",
    give: "送",

    pleasewait: "請求中，請稍後...",

    JoinGuild: "加入公會",
    GuildId: "公會ID",
    PlaceholderGuildId: "請輸入公會ID",

    InvitationCode: "邀請碼",

    noMore: "沒有更多了",

    Recommendation: "推薦人（選填）",
    nightLiveTime: "特殊時間",

    // 公會數據頁面
    GuildIncome: "機構收益",
    AnchorIncome: "主播收益",
    EffectiveLive: "有效開播",
    EffectiveDays: "有效天",
    Income: "收益",
    Duration: "時長",
  },

  anchorCenter: {
    todayLiveData: "今日直播數據",
    time: "時間",
    duration: "時長",
    income: "幸運金豆收益",
    giftRecord: "禮物記錄",
    withdraw: "提現",
    tipsUpdate: "注：當日數據每一分鐘更新",
    overallData: "總體數據",
    totalDays: "總天數",
    totalDuration: "總時長",
    totalTurnover: "總幸運金豆",
    totalIncome: "總底薪",
    totalBeans: "總金豆",
    dataListMonth: "數據列表【{month}】",
    filter: "篩選",
    date: "日期",
    turnover: "流水",
    beans: "金豆",
    luckyBeans: "幸運金豆",
    specialBeans: "特效金豆",
    baseSalary: "底薪",
    totalIncomeLabel: "總收入",
    zeroTime: "0時0分",
    year: "年",
    month: "月",
  },

  familyMain: {
    anchorList: "主播列表",
    anchorData: "主播數據",
    micTime: "主播麥時",
    micTimeData: "主播麥時數據",
    beansDetail: "金豆明細",
    beansDetailData: "金豆明細數據",
    withdrawDetail: "提現明細",
    withdrawDetailData: "提現明細數據",
    roomData: "房間數據",
    roomDataData: "房間數據數據",
    distributeBeans: "分配金豆",
    distributeBeansData: "分配金豆數據",
    privateShareStats: "私信/分享統計",
    privateShareStatsData: "私信/分享統計數據",
    roomTurnover: "房間流水",
    roomTurnoverData: "房間流水數據",
    incomeRecord: "收益記錄",
    incomeRecordData: "收益記錄數據",
    knapsackGiftDetail: "背包禮物明細",
    knapsackGiftData: "背包禮物數據",
    roomFilterTitle: "房間篩選",
    roomFilterConfirm: "完成",
    allRooms: "全部房間",
  },
  anchorList: {
    countLabel: "【{count}名主播】",
    searchPlaceholder: "請輸入主播ID",
    search: "搜索",
    joinTimeLabel: "加入時間：",
    noData: "暫無數據",
    nickNameFallback: "主播暱稱",
    invalidUserId: "請輸入數字ID",
  },

  salaryMain: {
    searchPlaceholder: "請輸入主播id搜索",
    dateSelect: "日期選擇",
    byDay: "按天",
    byRange: "按區間",
    searchTime: "搜索時間",
    to: "至",
    dataSummary: "數據匯總",
    totalMicTime: "總麥時",
    totalHeartGiftTurnover: "總幸運金豆",
    totalLuxuryGiftTurnover: "總金豆",
    member: "成員",
    anchorProfile: "主播資料",
    micTime: "麥時",
    heartGiftTurnover: "幸運金豆",
    luxuryGiftTurnover: "總金豆",
    roomNumber: "房間號",
    pleaseSelectTime: "請選擇時間",
    pleaseEnterNumber: "請輸入數字",
    selectAll: "全選",
    minute: "分",
    second: "秒",
  },

  micTime: {
    searchPlaceholder: "請輸入主播ID",
    search: "搜尋",
    dateSelect: "日期選擇",
    today: "當天",
    thisWeek: "本週",
    lastWeek: "上週",
    totalMicTime: "總麥時",
    date: "日期",
    anchorInfo: "主播資訊",
    micTime: "麥時",
    pleaseSelectTime: "請選擇時間",
    selectAll: "全選",
    minute: "分",
    second: "秒",
  },

  anchroOtayonii: {
    dateSelect: "日期選擇",
    byDay: "按天",
    byRange: "按區間",
    searchTime: "搜索時間",
    to: "至",
    dataSummary: "數據匯總",
    totalLuckyGift: "總幸運禮物",
    totalSpecialGift: "總特效禮物",
    totalKnapsackGift: "總背包禮物",
    anchorInfo: "主播資訊",
    luckyGift: "幸運禮物",
    specialGift: "特效禮物",
    knapsackGift: "背包禮物",
    pleaseSelectTime: "請選擇時間",
    selectAll: "全選",
  },

  roomCm: {
    dateSelect: "日期選擇",
    today: "當天",
    thisWeek: "本週",
    lastWeek: "上週",
    dataSummary: "數據匯總",
    totalTurnover: "總幸運金豆",
    totalTurnoverBeans: "總金豆",
    date: "日期",
    heartGiftTurnover: "幸運金豆",
    specialGiftTurnover: "總金豆",
    room: "房間",
    pleaseSelectTime: "請選擇時間",
    selectAll: "全選",
    minute: "分",
    second: "秒",
  },

  weekProfit: {
    dateSelect: "日期選擇",
    time: "時間",
    type: "類型",
    beans: "金豆",
    pleaseSelectTime: "請選擇時間",
  },

  coinManagement: {
    myGoldenbeans: "我的金豆",
    Withdraw: "提現",
    ExchangeGoldCoins: "兌換金幣",
    HostInformation: "主播資訊",
    WithdrawalCurrency: "提現幣種",
    SelectWithdrawalCurrency: "請選擇提現幣種",
    FiatCurrency: "法幣",
    PleaseSelectWithdrawalCurrency: "請選擇提現幣種",
    tips: "注：",
    tipsp0: "1.提現比例：10,000金豆=0.5USD",
    tipsp1: "2、提現門檻：100,000金豆，提現只能以10,000的倍數進行",
    tipsp2:
      "3、綁定提現賬戶，由於異國打款方式多樣、無固定證件等特性，後臺添加賬號為家族長時需支持多種認證類型【具體打款方式以目前情況為準】",
    tipsp3: "4、是否通過實名認證",
    tipsp4: "5、綁定手機號",
    tipsp5: "以上步驟任意一個未達成時，均無法提現，此時頁面提示用戶或引導開通",
    tipsp6: "① 僅提示",
    tipsp7: "② 跳轉到手機號綁定頁，綁定完成後返回上圖頁面",
    tipsp8: "③ 跳轉到實名認證頁，綁定完成後返回上圖頁面",
    tipsp9: "④ 跳轉到賬戶綁定頁，綁定完成後返回上圖頁面",
    tipsp10: "3、提現會有一定的手續費，根據不同的通路手續費也將不同。",

    tipsp11: "1.兌換比例：1000金豆=500金幣",
    tipsp12: "2.最低5000金豆兌換，必須為1000的倍數",
    tipsp13: "3.兌換成功後不可撤回，請謹慎兌換",

    num: "數量",
    Custom: "自定義",
    PleaseEnter: "請輸入",
    Redeem: "兌換",
    SelectType: "類型選擇",
    GoldBeans: "金豆",
    GoldCoin: "金幣",
    WithdrawalAmount: "提款金額",
    PleaseNum: " 輸入要提取的coin數量",
    All: "全部",
    Withdraw: "提現",
    balance: "餘額",

    Incomedetails: "收入明細",
    Expensedetails: "支出明細",
    Nobeans: "沒有可兌換金豆",

    Record: "交易記錄",
    WithdrawalRecord: "提現記錄",
  },

  //提现记录
  withdrawRecord: {
    withdrawAmount: "提现金额",
    withdrawStatus: "提现状态",
    NoData: "暂无数据",

    // 添加状态翻译
    UnderReview: "待審核",
    Processing: "處理中",
    Completed: "完成",
    Rejected: "拒絕",
    Failed: "失敗",

    Pending: "待處理",
    Success: "成功",
    NoMore: "沒有更多了",
    PleaseWait: "請求中，請稍後...",
    PleaseSelect: "請選擇",
    Date: "日期",
    RealAmount: "實到金額",
    Fee: "手續費",
    Status: "狀態",
    Remark: "備註",
  },

  contactUs: {
    Officialcustomerservice: "官方客服服務",
    ContactUs: "聯繫我們",
    Issueofguild: "公會入駐問題",
  },

  myInvitation: {
    MyGoldBeans: "我的金豆",
    Share: "分享邀請更多好友",
    CopyLink: "複製連結",
    GoldCoinEarnedToday: "今日獲得金幣",
    TotalGoldCoin: "累計金幣",
    tips: "邀請綁定新用戶充值任意金額都可獲得1%金幣獎勵",
    tips2: "註冊時間超過48小時無法綁定",
    MyInvitations: "我的邀請",
    BillingDetails: "賬單明細",
    Total: "合計",
    People: "人",
    GoldCoinGiven: "贈送金幣",
    GiveGoldCoin: "多送+",
  },

  userMisconduct: {
    title1: "內容違規 I",
    p1: "1.展示或傳播受限制內容：",
    p2: "包括在 Rain Live 的私聊、直播或其他功能中傳播色情、低俗、暴力或種族主義內容。",
    p3: "2.散布仇恨言論：",
    p4: "禁止發表針對宗教、種族、政治或國家身份的仇恨言論。",
    p5: "3.推廣或拉人：",
    p6: "禁止通過直播、私聊或審核過的評論邀請用戶加入其他應用程式或平台。",
    title2: "後果",
    p7: "涉及此類違規行為的賬戶、設備或 IP 地址可能會被封禁。",

    title3: "內容違規 II",
    p8: "1.分享私人信息：",
    p9: "禁止通過 Rain Live 的直播、評論或私聊功能傳播私人信息，例如電話號碼、賬號 ID、Facebook 賬戶、照片等。",
    p10: "2.賬戶濫用：",
    p11: "禁止向他人提供、出租或出售 Rain Live 賬戶。",
    p12: "3.利用私人信息：",
    p13: "禁止未經用戶同意使用或傳播其私人信息（照片、暱稱等）以謀取私利或惡意攻擊他人。",
    title4: "後果",
    p14: "違規用戶將被永久封號。",
  },

  landingPage: {
    info1: "Rain直播圈",
    info2: "Apl內部採購",
    item1: "45K條點評",
    item2: "下載",
    item3: "等級3級 3+",
    btn: "下載",
    title: "關於Rain直播",
    content:
      "Rain直播是一款暖心的面向所有人的在線直播軟件，包括語音、視頻、娛樂、遊戲等。平台聚集了高顏值主播，是一個有深度和內容的直播平台。激烈PK、活動不停，炫酷禮物、享受帝王般尊貴體驗。",
    tips: "Rain直播在線在社交應用程序的熱門免費列表中排名第一。",
  },

  equityLevel: {
    Experience: "經驗值",
    Level: "當前等級",
    Berikutnya: "距離升級",
    title1: "等級特權",
    desc1: "等級越高，圖標等級越尊貴，越容易得到心儀主播的青睞",
    title2: "如何升級",
    desc2: "1、用戶等級由您禮物消費的所得的經驗值數量決定",
    desc3: "2、您可以通過每日送禮物消費來獲得經驗值進行等級提升",
    desc4: "3、幸運禮物，每消耗1金幣獲得1經驗值",
    desc5: "4、特效禮物，每消耗1金幣獲得10經驗值",
    title3: "等級特權",
    desc6: "等級越高，圖標等級越尊貴，越容易得到用戶的青睞",
    title4: "如何升級",
    desc7: "1、主播等級由您收到禮物的所得的經驗值數量決定",
    desc8: "2、您可以通過每日收禮物數量來獲得經驗值進行等級提升",

    title6: "用戶等級",
    title7: "等級",
    title8: "等級勳章",
    title9: "主播等級",
    title10: "累計經驗值",
    LevelDescription: "等級說明",
  },

  applyJoin: {
    tips1: "請輸入您的 WhatsApp 帳號",
    title2: "照片要求",
    tips2: "請展示您的臉部和上半身，並將雙手擺成貓咪的姿勢",
    tips3: "此照片將用於公司的審核，並且有關部門會對其保密。",
    tips4: "照片必須是您自己的。",
    title3: "視頻要求",
    tops5: "視頻必須展示您本人。",
    tips6: "視頻長度應在 10 到 20 秒之間。",
    status1: "提交審核",
    status2: "審核中",
    status3: "審核成功",
    status4: "審核失敗",
    LiveMode: "直播模式",
    Video: "視頻",
    Voice: "語音",

    MP4: "請選擇MP4格式視頻",
    pngOrJpg: "請上傳 PNG 或 JPG 格式圖片",
    UploadingWait: "上傳中，請稍後",
    CompleteInformation: "請完善信息",
  },
  cancelAccount: {
    title: "申請註銷賬號",
    tips: "以下信息將被清空且無法找回",
    p1: "註銷賬號後，所有信息將被永久刪除（包括關注、粉絲等），您已購買的增值服務將不再保留且無法轉移至其他賬號（如VIP、靚號、頭像框等）。",
    p2: "綁定的Facebook、Twitter、Apple、Google賬號將會解除綁定，解除後可重新註冊。",
    p3: "您申請主播的信息將被解除綁定，解除後可重新綁定其他賬號。（如果您是直播主播用戶，您的主播信息可再次認證並啟動直播）。",
    p4: "賬號註銷後，賬戶剩餘的金幣、鑽石、經驗值、座駕、貴族等收益相關數據將被清空，如產生利益損失，將由賬號註銷申請人自行承擔。",
    p5: "如果您是公會長，提交註銷賬號後，公會將自動解散。（公會解散後，撤回申請也無法恢復公會）；如果您是公會成員，註銷賬號後將自動退出公會。（在15天內的申訴期內撤回註銷可恢復）。",
    p6: "如果您是家族長，提交註銷賬號時，需要先解散或退出家族。",
    p7: "如果您是家族成員（非家族長），提交註銷賬號時，將立即退出家族。（在15天內的申訴期內撤銷註銷不可恢復）。",
    p8: "提交註銷申請後，存在15天的申訴期。在申請期內登錄，將自動取消註銷。申訴期到期後，賬號將自動註銷且無法找回。如在此期間因非本人操作或誤操作等原因需要找回賬號，請聯繫客服申訴。(客服Whatsapp：+62 81188011180，或郵箱：rainlive888@gmail.com）",
  },

  Proxy: {
    Hello: "您好,",
    Welcome: "歡迎來到Rain Live！",
    Account: "賬號",
    Pleaseenter: "請輸入",
    Password: "密碼",
    Login: "登錄",
    MyAgent: "我的代理",
    Nickname: "代理暱稱",
    CoinBalance: "代理幣餘額",
    TransferRecord: "轉賬記錄",
    Recharge: "充值",
    TransferInformation: "請填寫轉賬信息",
    Reset: "重置",
    RecipientID: "對方ID",
    RecipientNickname: "對方暱稱",
    TransferAmount: "轉賬金額",
    Transfer: "轉賬",
    KindReminder: "溫馨提醒",
    DoubleCheck: "請核對一下信息，確保無誤",
    SelectAmount: "請選擇需要充值的金額",
    SelectMonth: "選擇月份",
    Username: "用戶名稱",
    TransferTime: "轉賬時間",
    AutoFill: "自動填充",
    Rechargeselection: "充值選擇",
    ProxyCurrency: "代理幣不足",
    PaymentAmount: "支付金額",
    PleaseSelectAmount: "請選擇充值金額",
  },
  bd: {
    index: {
      guildCount: "公会数",
      weekEstimatedIncome: "本周预估收益",
      lastWeekIncome: "上周收益",
      inviteCode: "邀请码",
      searchPlaceholder: "请输入公会ID",
      enterGuildId: "请输入公会ID",
      searchGuild: "搜索公会",
      lastWeek: "上周",
      weekIncome: "本周工会收益",
      myIncome: "我的收益",
      effectiveLive: "有效开播",
      bindDays: "绑定天数",
      summary: "汇总",
      guildName: "公会名称",
      guildId: "公会ID",
      guildIncome: "公会收益",
      effectiveLive: "有效开播",
      myIncome: "我的收益",
      date: "日期",
      noData: "暂无数据",
      searching: "搜索收益数据",
      showingSummary: "显示汇总数据",
      loading: "加载中...",
      loadFailed: "加载失败",
      networkError: "网络错误，请稍后重试",
      selectWeek: "选择周期",
    },
    incomeDetail: {
      title: "收益详情",
      lastWeekIncome: "上周收益",
      totalIncome: "总收益",
      guildId: "公会ID",
      date: "日期",
      thisWeek: "本周",
      lastWeek: "上周",
      beforeLastWeek: "上上周",
      thisMonth: "本月",
      lastMonth: "上月",
      guildName: "公会名称",
      guildIncome: "公会收益",
      search: "搜索",
      showSummary: "显示汇总",
      noData: "暂无数据",
      searching: "搜索收益数据",
      showingSummary: "显示汇总数据",
      guildId: "公会ID",
      guildName: "公会名称",
      guildIncome: "公会收益",
      effectiveLive: "有效开播",
      myIncome: "我的收益",
      date: "日期",
    },
  },
  noble: {
    expireTime: "到期時間",
    canReceive: "可領取{coin}金幣",
    receive: "立即領取",
    received: "已經領取",
    becomeNoble: "成為貴族",
    totalCanGet: "總計可獲得{price}{totalCoin}金幣",
    silver: "白銀",
    gold: "黃金",
    platinum: "鉑金",
    diamond: "鑽石",
    obsidian: "黑曜",
    privileges: {
      getCoin: "領金幣",
      avatarFrame: "頭像框",
      medal: "勳章",
      vehicle: "座駕",
      purchaseNotification: "購買通知",
      chatBubble: "聊天氣泡",
      colorfulNickname: "彩色暱稱",
      specialId: "專屬ID",
      mystery: "神秘人",
      exclusiveService: "專屬服務",
      Effect: "房間入場特效",
    },
    contactOperation: "請聯繫運營獲取",
    receiveSuccess: "領取成功",
    level1Recharge: "白銀貴族 /30天",
    level2Recharge: "黃金貴族 /30天",
    level3Recharge: "鉑金貴族 /30天",
    level4Recharge: "鑽石貴族 /30天",
    level5Recharge: "黑曜貴族 /30天",
  },
  bonusActivity: {
    title: "直播額外獎勵",
    activityTime: "活動時間：2025年4月7日至2025年5月4日 (UTC+8)",
    rewardRules: "獎勵規則",
    reward: "獎勵",
    totalReceived: "總計領取",
    bonus: "獎金",
    claim: "領取",
    claimed: "已領取",
    notAchieved: "未達成",
    duration: "長時 (小時)",
    target: "目標 (金幣)",
    note: "註：達成目標後，獎金可於次日領取。",
    activityCalendar: "活動日曆",
    april: "四月",
    may: "五月",
    claimSuccess: "領取成功",
  },
  bonusActivityRule: {
    activityDescription: "活動說明",
    descriptionContent: "主播在基礎獎勵之上，還將額外獲得Rain Live給予的獎勵。",
    activityTime: "活動時間",
    timeContent1: "2025年4月7日至2025年5月4日（UTC+8）",
    timeContent2: "每天的0點(UTC+8)時，將開啟下一天的獎勵",
    claimMethod: "領取方式",
    claimContent: "當天達成目標時，次日可手動領取獎勵。",
    rewardTable: "獎勵表：",
    targetTurnover: "目標流水",
    activityReward: "活動獎勵",
  },
  inviteFriends: {
    invitationEventTitle: "邀請活動",
    inviteAndEarnRewards: "邀請有獎",
    eventPeriod: "活動時間：4月7日 00:00 - 5月4日 23:59:59 (UTC+8)",
    invitationRecord: "邀請記錄",
    eventDetails: "活動說明",
    week1DateRange: "第一週：4月7日 - 4月13日",
    totalInvitedExample: "已邀請人數",
    level1RewardText: "Lv.1 邀請20人 20000金幣",
    level2RewardText: "Lv.2 邀請50人 50000金幣",
    level3RewardText: "Lv.3 邀請100人 100000金幣",
    statusClaimed: "已領取",
    actionClaim: "領取",
    statusNotAchieved: "未達成",
    topUpRewardsLabel: "充值獎勵：",
    copyInvitationLink: "複製邀請鏈接",
    rewardNote: "註：被邀請人充值時，你可獲得對應金幣的2%獎勵。",
    copySuccess: "複製成功",
    claimSuccessExample: "成功領取20000金幣",
    userIDLabel: "用戶ID",
    userNameLabel: "用戶名稱",
    timeLabel: "時間",
    topUpLabel: "充值",
    eventPurposeTitle: "【活動目的】",
    eventPurposeDesc:
      "為感謝用戶長期以來對 Rain Live 的支持與喜愛，平台特推出「邀請好友・多重有禮」活動，誠邀您與好友共享精彩直播體驗！",
    eventDurationTitle: "【活動時間】",
    eventDateRange: "2025年4月7日至2025年5月",
    eventCycleDesc: "共4週，每週一 0 點 (UTC+8) 開啟新周期獎勵",
    rewardRulesTitle: "【獎勵規則】",
    rewardRulesDesc1: "除本次活動獎勵外，還可正常享受原邀請獎勵：",
    rewardRulesDesc2: "用戶充值金幣的2%將額外獎勵給邀請人。",
    importantNotesTitle: "【注意事項】",
    importantNotesDesc:
      "⚠️ 禁止通過虛假帳號、機器註冊等惡意行為刷取獎勵，一經發現將立即收回所有獎勵，並可能限制帳號功能；",
  },
  bonusPoints: {
    activityTime: "活動時間",
    resetTime: "每日0點(UTC+8)重置",
    pointsReward: "積分獎勵",
    coinsReward: "金幣獎勵",
    participationTimes: "參與{times}次",
    points: "積分",
    exchange: "兌換",
    pointsMall: "積分商城",
    betSum: "當前流水",
    note: "註",
    rule1: "1、可透過完成每日積分任務獲得積分",
    rule2: "2、積分商城的獎勵將會不定期更換",
    rule3: "3、兌換成功後，積分不可退換，請謹慎兌換",
    coins: "金幣",
    claim: "領取",
    claimed: "已領取",
    notAchieved: "未達成",
    reach: "達成",
  },

  // 公會活動
  guildActivity: {
    activityRules: "活動規則",
    rulesContent: {
      activityTime: "活動時間：9月29日開始",
      rankingRewards: "排名獎勵",
      requirements: "要求",
      rewardDistribution: "獎勵發放",
      rewardList: {
        first: "第一名：1000000金豆",
        second: "第二名：500000金豆",
        thirdToFifth: "第3-5名：250000金豆",
      },
      requirementText:
        "機構主播當週必須完成至少30場直播，每位主播每天直播超過2小時算作一次",
      distributionText: "獎勵將於第二週發放",
    },
  },

  // 魅力榜/消費榜排行榜
  charmRanking: {
    charmRanking: "魅力榜",
    consumptionRanking: "消費榜",
    dailyRanking: "日榜",
    weeklyRanking: "周榜",
    userNickname: "用戶暱稱",
    distanceToPrevious: "距前一名",
    noRankingData: "暫無排行榜數據",
    requestFailed: "請求失敗",
  },

  // 邀請活動
  inviteActivity: {
    title: "邀請3人必得獎勵",
    rule: "規則",
    alreadyJoined: "已加入",
    inviteImmediately: "立即邀請",
    callNumber: "邀請",
    myRewards: "我的獎勵",
    claim: "領取",
    claimed: "已領取",
    people: "人",
    inviteFriends: "邀請朋友",
    processTitle: "邀請流程：",
    step1: "1.發送鏈接給朋友",
    step2: "2.朋友下載並註冊",
    step3: "3.獲得免費金幣",
    rulesTitle: "邀請規則",
    rulesContent: {
      rule1: "邀請達到3人時，可領取16666金豆",
      rule2: "邀請達到25人時，可再領取36666金豆",
      rule3: "邀請達到100人時，可再領取88888金豆總計可領142220金豆。",
      rule4: "獎勵於活動頁面手動領取。",
      rule5: "嚴禁惡意刷取人數，若發現將進行封號處理",
    },
    close: "關閉",
    inviteFeatureComingSoon: "邀請功能即將上線",
    rewardReceived: "成功獲得 {amount} 金幣！",
  },

  // 贈送金幣頁面
  giftGoldCoins: {
    maxGiftableCoins: "最大可贈送金幣",
    giftAmount: "贈送金幣數量",
    customAmount: "自定義贈送金幣數量",
    enterAmount: "請輸入金額",
    quantity: "數量",
    giftToOtherAccounts: "贈送至其他賬號",
    exceedMaxAmount: "金額不能超過最大可贈送數量",
    amountSet: "金額設置成功",
    invalidAmount: "請輸入有效金額",
    selectValidAmount: "請選擇有效金額",
    confirmTitle: "確認贈送",
    confirmMessage: "確定要贈送 {amount} 金幣嗎？",
    giftSuccess: "贈送成功",
    giftId: "贈送ID",
    enterGiftId: "請輸入ID",
    pleaseEnterGiftId: "請輸入贈送ID",
    giftCompleted: "贈送完成！",
    giftedToId: "贈送至ID",
    networkError: "網絡錯誤，請稍後重試",
    confirm: "確定",
  },

  // 裝扮商店
  shop: {
    headerTitle: "個人裝扮",
    back: "返回",
    shoppingBag: "購物袋",
    loading: "加載中...",
    noProducts: "暫無商品",
    unnamedProduct: "未命名商品",
    day: "天",
    myCoins: "我的金幣",
    exchangeNow: "立即兌換",
    notSelected: "未選中",
    loginExpired: "登錄失效，請重新登錄",
    categoryNotExists: "分類不存在",
    loadFailed: "加載失敗",
    loadFailedRetry: "加載失敗，請重試",
    pleaseSelectProduct: "請先選擇商品",
    productNotExists: "商品不存在",
    insufficientCoins: "金幣不足，需要{amount}金幣",
    exchangeSuccess: "兌換成功",
    exchangeFailed: "兌換失敗",
    categories: {
      hot: "熱門",
      avatarFrame: "頭像框",
      entryEffect: "進場特效",
      chatBubble: "聊天氣泡",
      mount: "坐騎",
    },
    recharge: "充值 >",
    validityPeriod: "有效期:",
    myCoinsLabel: "我的金幣:",
  },
  myDecoration: {
    headerTitle: "我的裝扮",
    back: "返回",
    noWearingDecoration: "暫無選中的穿戴裝扮",
    loading: "加載中...",
    noDecoration: "暫無裝扮",
    unnamedDecoration: "未命名裝扮",
    permanent: "永久",
    wearing: "穿戴中",
    pleaseSelectDecoration: "請選擇裝扮",
    removeDecoration: "卸下裝扮",
    wearNow: "立即穿戴",
    pleaseSelectDecorationFirst: "請先選擇裝扮",
    decorationNotExists: "裝扮不存在",
    loginExpired: "登錄失效，請重新登錄",
    loadFailed: "加載失敗",
    loadFailedRetry: "加載失敗，請重試",
    wearSuccess: "穿戴成功",
    wearFailed: "穿戴失敗",
    categories: {
      avatarFrame: "頭像框",
      entryEffect: "進場特效",
      chatBubble: "聊天氣泡",
      mount: "坐騎",
    },
  },
  // 聖誕活動/幸運星活動
  christmasActivity: {
    dailyLuckyStar: "每日幸運星",
    weeklyLuckyStar: "每週幸運星",
    startTime: "Start time:",
    obtainedCount: "獲得個數",
    moreChance: "數量越多機會越多",
    participated: "已參與",
    notParticipated: "未參與",
    historyRecord: "歷史記錄",
    myRecord: "我的記錄",
    noRecord: "暫無記錄",
    loading: "加載中...",
    noMore: "沒有更多了",
    coin: "金幣",
    unit: "個",
    notWon: "未中獎",
    conditionNotMet: "條件未滿足",
    claimSuccess: "領取成功",
    getRecordFailed: "獲取記錄失敗",
    rules: {
      title: "活動規則",
      rule1: "每日幸運星",
      rule2: "每日幸運星活動，所有用戶可參與。",
      rule3:
        "向主播贈送對應禮物時，可獲得禮物個數累計，當贈送的禮物數量滿足要求時，即可參與到紅包開獎中，每次都將會有幸運兒獲得金幣獎勵。",
      rule4: "贈送禮物個數越多，獲獎機會越高",
      rule5: "每週幸運星",
      rule6: "週幸運星活動，所有的主播可參與。",
      rule7:
        "當收到用戶贈送的對應禮物時，會獲得數量累計，收到足夠的禮物數量時，可參與週幸運星紅包開啟，每次都將有幸運兒獲得獎勵。",
      rule8: "獲得禮物個數越高，獲獎機會越高",
      rule9: "其他說明",
      rule10: "此次活動為福利大回饋。",
      rule11: "僅向其他主播贈送時，可累計個數。",
      rule12: "嚴禁利用漏洞獲得獎勵。",
      rule13: "每個時間段的獎勵將自動發放，可查看獲獎記錄，了解中獎情況",
    },
  },
  // 幸運星積分排行活動
  fortuneStarActivity: {
    points: "積分",
    pointsRanking: "積分排行",
    currentRoundPoints: "本場積分",
    lastRoundPoints: "上場積分",
    defaultUserName: "用戶名稱",
    noData: "暫無數據",
    activityRules: "規則",
    historyRecord: "歷史記錄",
    earnedPoints: "獲得積分",
    participated: "已參與",
    notParticipated: "未滿足",
    myRecord: "我的記錄",
    userId: "ID",
    userNickname: "用戶暱稱",
    sessionTime: "場次時間",
    winningStatus: "中獎情況",
    won: "已中獎",
    notWon: "未中獎",
    rules: {
      rule1: "活動期間，用戶通過贈送指定禮物可獲得積分",
      rule2: "積分將實時累計，可查看當前積分排名",
      rule3: "活動結束後，排名靠前的用戶將獲得豐厚獎勵",
      rule4: "嚴禁使用任何作弊手段獲取積分，違者將取消資格",
      rule5: "活動最終解釋權歸平台所有",
    },
  },

  // 盲盒活動
  blindBox: {
    title: "玩法介紹",
    ruleTitle: "玩法介紹",
    rule1:
      "每{price}金幣可開{text}一次，用戶贈送該禮物後可變出不同的禮物，變出禮物將會自動贈送給所指定的麥上用戶",
    rule2: "贈送{text}用戶在該禮物所變出的禮物自動送出後可獲得對應的金豆。",
    rewardTip: "獎勵提示",
    probabilityDesc: "具體概率如下：",
    prize: "獎品",
    probability: "概率",
    value: "價值",
  },
  pcOfficial: {
    navHome: "首頁",
    navLive: "實時直播",
    navGameHall: "遊戲大廳",
    received: "收到",
    heroTagline: "全球領先的 Web4 娛樂平台",
    heroTaglineSub:
      "性感主播 7*24 小時實時互動，頂級鏈遊體驗。基於去中心化技術，確保每一筆交易即時獎勵，公平公正",
    downloadNow: "立即下載",
    recommendTitle: "熱門主播推薦",
    recommendSub: "萬千女神實時互動，帶你領略 P2E 鏈遊魅力",
    hotGamingTitle: "熱門遊戲",
    hotGamingSub: "真實玩家，真實排名。你會是下一個傳奇嗎？",
    casinoTitle: "娛樂城",
    casinoDesc1: "與真人荷官同場競技，暢玩百家樂，",
    casinoDesc2: "輪盤與 21 點，高清沉浸體驗",
    slotsTitle: "老虎機",
    slotsDesc: "海量高品質老虎機，98.5% RTP 高回報",
    gamingTitle: "遊戲",
    gamingDesc: "不止轉盤，體驗多人競技技巧遊戲",
    whyTitle: "為什麼選擇 Rain Live",
    whyItem1Title: "公平公正",
    whyItem1Desc: "經審計 RNG，保證每局公平",
    whyItem2Title: "極速到賬",
    whyItem2Desc: "提現快速，到賬及時",
    whyItem3Title: "匿名隱私",
    whyItem3Desc: "無需個人信息，100% 隱私保護",
    whyItem4Title: "去中心化",
    whyItem4Desc: "鏈上透明、安全可信",
    terms: "服務條款",
    privacy: "隱私政策",
  },
};
